// Forces a real download for [data-owners-guide-download] links.
//
// The native `download` attribute is ignored on cross-origin URLs, and Shopify serves
// uploaded files from cdn.shopify.com. Without this, the "download" button would just
// open the PDF in the browser viewer, doing the same thing as the "view online" button.
// So the file is fetched as a blob and saved locally instead. Any failure (CORS, network)
// falls back to opening the file, which is the browser's default behaviour anyway.
(function () {
  const SELECTOR = "[data-owners-guide-download]";
  const REVOKE_DELAY = 10000;

  function filenameFor(link) {
    if (link.dataset.filename) {
      return link.dataset.filename;
    }

    try {
      const path = new URL(link.href).pathname;
      return decodeURIComponent(path.split("/").pop()) || "download";
    } catch (error) {
      return "download";
    }
  }

  async function saveAsBlob(link) {
    const response = await fetch(link.href, { credentials: "omit" });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const objectUrl = URL.createObjectURL(await response.blob());
    const target = document.createElement("a");

    target.href = objectUrl;
    target.download = filenameFor(link);
    document.body.appendChild(target);
    target.click();
    target.remove();

    // Give the browser a moment to start writing the file before releasing the blob.
    setTimeout(() => URL.revokeObjectURL(objectUrl), REVOKE_DELAY);
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest(SELECTOR);

    if (!link) {
      return;
    }

    // Let modified clicks (open in new tab, save link as) behave natively.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (link.dataset.downloading === "true") {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    link.dataset.downloading = "true";
    link.setAttribute("aria-busy", "true");

    saveAsBlob(link)
      .catch(() => {
        window.open(link.href, "_blank", "noopener");
      })
      .finally(() => {
        delete link.dataset.downloading;
        link.removeAttribute("aria-busy");
      });
  });
})();
